import React from 'react';
import { NEXA_INTRODUCTION_HELP } from '@src/utils/help/links';
import { DisclaimerTextContainer } from './styled';

function DisclaimerText({ style = {} }) {
  return (
    <DisclaimerTextContainer style={style}>
      <p>
        Conviva&apos;s PromptAI is built on LLM technology. LLMS can generate inaccurate output.
        When in doubt, refer to the &nbsp;
        <a href={NEXA_INTRODUCTION_HELP} target="_blank" rel="noopener noreferrer">
          Conviva Learning Center
        </a>
        &nbsp; documentation as authoritative source. By using PromptAI, you agree to allow Conviva
        to collect information to improve our products and services. If you do not wish to allow
        this, please do not use PromptAI. Built with Meta Llama 3.
      </p>
    </DisclaimerTextContainer>
  );
}

export default DisclaimerText;
